import React  from "react";
import { useParams } from 'react-router-dom';
import SalaryAdditionForm from "./components/SalaryAdditionForm";

const EditSalaryAddition = () => {
	const { additionId } = useParams();
    
	return (
	    <div>
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<SalaryAdditionForm recordId={additionId} mode="edit"/>
	      </div>
	    </div>
    );
};

export default EditSalaryAddition;